import { Link } from "gatsby";
import { styled } from "styled-components";

export const FooterContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.navy};
  color: ${({ theme }) => theme.colors.white};
`;

export const FooterHeader = styled.div`
  p {
    letter-spacing: 0;
  }
`;

export const FooterContent = styled.div``;

export const FooterMenuItem = styled.div`
  ${({ theme }) => theme.typography.bodyText["b6impactbold"]}
  color: ${({ theme }) => theme.colors.white};
`;

export const FooterLink = styled(Link)`
  display: block;
  color: ${({ theme }) => theme.colors.lavender};
  ${({ theme }) => theme.typography.bodyText["b6impact"]}

  &:hover {
    color: #ccd7ff;
  }
`;

export const FooterBottom = styled.div`
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;

  a {
    color: ${({ theme }) => theme.colors.lavender};
  }
`;
